import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop, map } from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ReactToPrint from "react-to-print";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import {
  commaFormatted,
  normalizeAmount,
} from '../../../../utils/transformer.util';
import {
  Select,
  SearchSelect,
  Button,
} from '../../../../components/base';


const MySwal = withReactContent(Swal);

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class PiutangSiswa extends PureComponent {
  constructor(props) {
    super(props);

    this._onFormChange = this._onFormChange.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    // this._getStudentSPPOptions = this._getStudentSPPOptions.bind(this);
    // this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._getUnitsVaCodeOptions = this._getUnitsVaCodeOptions.bind(this);
    this._getMsTempsSiswaOptions = this._getMsTempsSiswaOptions.bind(this);
    this._getPrmStudentBlockGeneral = this._getPrmStudentBlockGeneral.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this.getPrmPaymentsNon = this.getPrmPaymentsNon.bind(this);
    this.getPrmPaymentsNonGeneral = this.getPrmPaymentsNonGeneral.bind(this);
    this._onClickEditNon = this._onClickEditNon.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { id, levels_id } = school_unit;
    this.state = {
      expanded: null,
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      list: [],
      filters: {},
      form: {
        value: {
          total: '',
          classes: [],
          levels_id,
          periods: '',
          listhistory: [],
          units_id:'',
          classes_id: '',
          pg_code: '',
          payload: [],
          listsiswa: [],
          listcicilan: [],
          listsiswa2: [],
          user_id: user.id,
        },
        error: {
          classes: '',
          levels: '',
          listhistory: '',
          listsiswa: '',
          listcicilan: '',
          listsiswa2: '',
        },
      },
      param: {},
      filtered: false,
    };
    this.checkboxRefs = [];
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  componentDidMount() {
    const { user } = this.props;
    const { school_unit, organizations_id, user_group } = user;
    const { content, filters, form } = this.state;
    let savedFilters = JSON.parse(window.localStorage.getItem('studentBlockFilters'))
      || filters;
    let savedForm = JSON.parse(window.localStorage.getItem('studentBlockForm')) || '';
    if (savedForm != '' && user.id != savedForm.value.user_id) {
      savedForm = '';
      savedFilters = filters;
    }

    console.log(savedFilters.units_id);
    console.log(savedForm);

    if (isEmpty(content.list)) {
      // this._onSearchContent({ page: 1 });
    }
    this._initializeData(savedFilters);
    if (savedForm != '') {
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            units_id: savedFilters.units_id ? savedFilters.units_id : '',

            update: true,
          },
        },
         filters: {
          ...prevState.filters,
            units_id: savedFilters.units_id ? savedFilters.units_id : '',

        },
      }));

      if (user_group.name === 'pusat' || user_group.name === 'perwakilan') {
        this._getPeriodsOptions({ units_id: savedForm.value.units_id ? savedForm.value.units_id.value : '' });
        //   this._getParamOptionsAcademics("classrooms", {
        //    levels_id: savedForm.value.levels_id,
        //    organizations_id,
        //    units_id: savedForm.value.units_id.value
        //  });
      }
      // this._getPeriodsOptions({ units_id: savedForm.value.units_id?savedForm.value.units_id.value:'' });

      if (organizations_id == 3) {
        // this._getUnitsVaCodeOptions();
        this._getMsTempsSiswaOptions({
          units_id: savedForm.value.units_id.attributes.va_code,
        });
      } else {
        // this._getSchoolUnitsOptions();
        this._getPrmStudentBlockGeneral({
          units_id: savedFilters.units_id.value,
        });
      }
    }
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { form } = this.state;
    const { school_unit, user_group, organizations_id } = user;

    await this._getSchoolUnitsOptions();

    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        // units_id : savedFilters.units_id,
      },
    }),
    () => {
      this._onSearchContent();
    });
  }

  async _getPrmStudentBlockGeneral(filters = {}) {
    const { getPrmStudentBlockGeneralOptions } = this.props;
    const res = await getPrmStudentBlockGeneralOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getMsTempsSiswaOptions(filters = {}) {
    const { getMsTempsSiswaOptions } = this.props;
    const res = await getMsTempsSiswaOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student: res,
      },
    }));
  }

  async _getUnitsVaCodeOptions(filters = {}) {
    const { getUnitsVaCodeOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getUnitsVaCodeOptions(filters);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  _onClickEdit(val) {
    const { filters, param } = this.state;
    const { students_id } = filters;
    const { history } = this.props;

    let student_name = '';
    let student_va = '';

    if (!isEmpty(students_id)) {
      const str = students_id.label;
      const result = str.indexOf('-');
      student_name = str.substring(result + 2, str.length);
      student_va = str.substring(0, result - 1);
    }
    // console.log("ini val" +val)
    history.push('/dashboard/tagihan-siswa/create-invoice/rutin', {
      getdata: val,
      isEdit: true,
      data: {
        user_id: 0,
        name: filters.students_id.label,
        id: filters.students_id.value,
        name: student_name,
        no_va: student_va,
        entrance_year: students_id.academics_year,
      },
    });
  }

  _onClickEditNon(val) {
    const { history, user } = this.props;
    const { organizations_id } = user;
    // console.log("ini val" +val)
    if (organizations_id == 4 || organizations_id == 5) {
      history.push('/dashboard/tagihan-siswa/create-invoice/tidak-rutin-general',
        { data: val, isEdit: true });
    } else {
      history.push('/dashboard/tagihan-siswa/create-invoice/tidak-rutin', {
        data: val,
        isEdit: true,
      });
    }
  }

   _setIsBlocked(isBlocked) {
    const { form, filters, param } = this.state;
    const { value } = form;
    const { listsiswa, classes_id } = value;
    const newList = JSON.parse(JSON.stringify(listsiswa));
    newList.forEach((item) => {
      item.is_blocked = isBlocked;
    });

    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          listsiswa: newList,
        },
      },
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      if (name === 'is_blocked' && !inputArray) {
        this._setIsBlocked(value);
      }
      // this._onSearchContent();
    });
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState(prevState => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            period: data.value,
          },
        }));
      }
    });

    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, user_group } = user;
    const { filters, param } = this.state;
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      window.localStorage.setItem('studentBlockFilters',
        JSON.stringify(this.state.filters));
      window.localStorage.setItem('studentBlockForm',
        JSON.stringify(this.state.form));
        console.log(this.state)
      if (name === 'units_id') {
        delete filters.students_id;
        const param = this.state.param.units;

        const va_code = param.find(i => i.value == value.value)
          ? param.find(i => i.value == value.value).attributes.va_code
          : '';

        this._getPeriodsOptions({ units_id: value.value });

        if (organizations_id == 3) {
          this._getMsTempsSiswaOptions({ units_id: va_code });
        } else {
          this._getPrmStudentBlockGeneral({ units_id: [value.value] });
        }
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              units_id: value,
              students_id: [],

            },
          },
        }));
      }
      this._onSearchContent();
    });
  }

  onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    this._onSearchContent({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { students_id, jenis, payments_id, units_id } = filters;
    const { value } = form;
    const { subject_id, currents_year } = value;
   
    if (filters.date === '') {
      delete filters.date;
    }
    if (filters.date_to === '') {
      delete filters.date_to;
    }

    this.setState({
      content: initialContent,
    },
    async () => {
      try {
        const { handleListBlockStudents, user } = this.props;
        const { school_unit, organizations_id, user_group } = user;
        let year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;

          const units = user_group.name == 'pusat' || user_group.name == 'perwakilan'
          ? units_id.value
          : school_unit.id;
          
        if (month < 7) {
          year -= 1;
        }
        const result = await handleListBlockStudents({
          ...params,
          units_id: units,
          organizations_id: organizations_id,
          filters,
        });

        // untuk set state list payment gateway dan offline
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listsiswa: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listsiswa: [],
            },
          },
        }));
      }
    });
  }

  async _getStudentSPPOptions(filters = {}) {
    const { getStudentSPPOptions } = this.props;
    const res = await getStudentSPPOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        student: res,
      },
    }));
  }

  async getPrmPaymentsNon() {
    const { getPrmPaymentsNon } = this.props;
    const res = await getPrmPaymentsNon();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_payments: res,
      },
    }));
  }

  async getPrmPaymentsNonGeneral() {
    const { getPrmPaymentsNonGeneral } = this.props;
    const res = await getPrmPaymentsNonGeneral();
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_payments: res,
      },
    }));
  }

   async onSubmit() {
    const { history, handleSaveBlockStudent, user } = this.props;
    const { organizations_id } = user;
    const { form } = this.state;
    const { value } = form;

    const label = value.students_id.label;
    console.log(value)
    await handleSaveBlockStudent({
      organizations_id : organizations_id,
      units_id : value.units_id.value,
      no_va : value.students_id.value,
      fullname :  label.split(" - ")[1],
    });
    history.push('/dashboard/tagihan-siswa/piutang-siswa');
      history.go(0);

  }

   async onUpdate() {
    const { history, handleUpdateBlockStudent } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleUpdateBlockStudent(value);
    history.push('/dashboard/tagihan-siswa/piutang-siswa');
      history.go(0);

  }

  render() {
    const {
      param, form, content, filters, listH2h,
    } = this.state;
    const {
      date = '',
      date_to = '',
      payments_type,
      jenis,
      payments_id,
      period,
    } = filters;
    const { listsiswa, listcicilan, listsiswa2 } = form.value;
    const { user } = this.props;
    const { organizations_id, user_group } = user;
    const paymentstype = [
      { label: 'Payment Gateway', value: 'paymentgateway' },
      { label: 'Offline', value: 'offline' },
      { label: 'H2H', value: 'h2h' },
    ];
    const { prm_payments, student } = param;
    const count = 0;

    const bulan = [
      { label: 'Juli' },
      { label: 'Agustus' },
      { label: 'September' },
      { label: 'Oktober' },
      { label: 'November' },
      { label: 'Desember' },
      { label: 'Januari' },
      { label: 'Februari' },
      { label: 'Maret' },
      { label: 'April' },
      { label: 'Mei' },
      { label: 'Juni' },
    ];

    if (date > date_to) {
      form.error.date = 'Format Tanggal Salah';
      form.error.date_to = 'Format Tanggal Salah';
    } else {
      form.error.date = '';
      form.error.date_to = '';
    }

    const prm_is_block = [
      { value: 0, label: 'Open' },
      { value: 1, label: 'Block' },
    ];

    // const no_va = student
    //   ? student.find(item => item.value == students_id.value)
    //     ? student.find(item => item.value == students_id.value).value
    //     : ''
    //   : '';
    // const label = student
    //   ? student.find(item => item.value == students_id.value)
    //     ? student.find(item => item.value == students_id.value).label
    //     : ''
    //   : '';
    // const student_name = label.slice(14);
    // const classrooms_name = student
    //   ? student.find(item => item.value == students_id.value)

    //     ? student.find(item => item.value == students_id.value).classrooms
    //     : ''
    //   : '';
    // console.log(classrooms_name);
    const prm_jenis = [
      { label: organizations_id == 3 ? 'SPP' : 'RUTIN', value: 'rutin' },
      {
        label: organizations_id == 3 ? 'DPP/UPP' : 'NON RUTIN',
        value: 'nonrutin',
      },
    ];

    const prm_period = param.periods ? param.periods : '';
    const period_label = prm_period
      ? prm_period.find(i => i.value == period)
        ? prm_period.find(i => i.value == period).label
        : ''
      : '';
    if (!isEmpty(param.periods) && period) {
      const period_label = param.periods.find(i => i.value == period)
        ? param.periods.find(i => i.value == period).label
        : '';
      if (period_label && period_label != '') {
        const period_idx = period_label.indexOf('-');
        form.value.currents_year = period_label.substring(0, period_idx);
      }
    }
    const data_inv = listsiswa ? listsiswa.data_inv : '';

    // console.log(ttlUSK);
    const componentRef = React.createRef();
   const printTest = `
  @media print {
    @page {
      page-break-inside: avoid;
    }
    * {
      -webkit-print-color-adjust: exact;
    }

    /* Override ukuran font & padding table saat print */
    table {
      width: 100% !important; 
      font-size: 14pt !important;
    }
    table td, table th {
      padding: 8px 12px !important;
    }
  }
`;

    return (
      <div className="manage-registration">
        <div className="budget__title">
          <h1>Piutang Siswa</h1>
          <hr />
        </div>
        <div className="absensi-rekap__custom-form">
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <SearchSelect
                noMargin
                async={false}
                name="units_id"
                list={param.units}
                inputArray
                onClick={this._onChangeFilter}
                placeholder="Pilih Unit"
                value={form.value.units_id}
                rightIcon="icon-search"
                label="Pilih Unit"
              />
            </div>
            <div className="absensi-rekap__custom-form-column__field">
              <SearchSelect
                noMargin
                async={false}
                name="students_id"
                list={param.student}
                inputArray
                onClick={this._onFormChange}
                placeholder="Pilih Siswa"
                value={form.value.students_id}
                // value="061190207"
                rightIcon="icon-search"
                label="Siswa"
              />
            </div>
          </div>
          <br />
        </div>
        <div className="beginning-balance__button-wrapper">
          <Button 
          type="submit" title="SIMPAN" onClick={this.onSubmit}
          />
        </div>
          <div className="manage-registration">
                <div className="fund-request__content">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>No VA</th>
                        <th>Nama Lengkap</th>
                        <th>Piutang Rutin</th>
                        <th>Piutang Non Rutin</th>
                        <th>Blokir Siswa PPDB</th>
                      </tr>
                    </thead>
                    <tbody>
                      {map(listsiswa, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                            {idx + 1}
                          </td>
                          <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                            {list.no_va}
                          </td>
                          <td
                            key={`table_${idx}`}
                            style={{ textTransform: 'capitalize' }}
                          >
                            {(list.fullname)}
                          </td>
                          <td>{commaFormatted(list.rutin[0]?list.rutin[0].nominal_rutin:'')}</td>
                          <td>{commaFormatted(list.nonrutin[0]?list.nonrutin[0].nominal_nonrutin:'')}</td>
                          
                          {/* {this._renderButtons(list)} */}
                          <td key={`table__${idx}`}>
                            <Select
                              placeholder="Pilihan"
                              data-input-array
                              data-array-position={idx}
                              data-field-name="listsiswa"
                              name="is_block"
                              value={list.is_block}
                              // data={form.value.graduate === 1?[...lulus, ...tidak_lulus]:[...naik, ...tidak_naik]}
                              data={prm_is_block}
                              onChange={this._onFormChange}
                              // disabled={classrooms_id2 ? false : true}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="add-budget">
                    <Button title="UPDATE" onClick={this.onUpdate} />
                  </div>
                </div>
              </div>
      </div>
    );
  }
}
PiutangSiswa.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
PiutangSiswa.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
